var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video-box-modal-modal" },
    [
      _vm.show
        ? [
            _c(
              "div",
              { staticClass: "static" },
              [
                _c("transition", { attrs: { appear: "", name: "fade" } }, [
                  _vm.show
                    ? _c("div", {
                        staticClass: "video-box-modal-backdrop",
                        on: { click: _vm.dismiss },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { appear: "", name: "focus" } },
                  [
                    _vm.show
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "contents-menu",
                              on: {
                                close: function ($event) {
                                  _vm.showVideoModal = false
                                },
                              },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "menu-close",
                                  on: { click: _vm.dismiss },
                                },
                                [_vm._v("Close")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "video-box-modal-outer" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "video-box-modal-container",
                                    },
                                    [
                                      _c("iframe", {
                                        attrs: {
                                          src: `${_vm.videoUrl}?rel=0&controls=1&showinfo=0;&autoplay=1`,
                                          width: "100%",
                                          frameborder: "0",
                                          allow:
                                            "autoplay; encrypted-media; picture-in-picture",
                                          allowfullscreen: "",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "video-box-modal-footer" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "menu-close",
                                          on: { click: _vm.dismiss },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Close This Window\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }